import {ProductTypeChargerRelationDTO} from "../../Ope/ProductType/ProductTypeChargerRelationDTO";

export class ProductType {
  public id!: number
  public name!: string;
  public ebike!: boolean;
  public moving!: boolean;
  public monitored!: boolean;
  public chargers?: ProductTypeChargerRelationDTO[];
}
